<template>
</template>

<script>
import test from '#/utils/EventStreamTest.js'
export default {
	mounted() {
		test()
	},
	data() {
		return {}
	},
	methods: {}
}
</script>

